// extracted by mini-css-extract-plugin
export default {"registry-totals-container":"wdmYu8KyJ4","registryTotalsContainer":"wdmYu8KyJ4","registry-total-box":"_3DL2eow6SS","registryTotalBox":"_3DL2eow6SS"};